import { createModelBase } from "nyax";
import { Dependencies } from "src/dependencies";

export const ModelBase = createModelBase<Dependencies>();
